// frontend/src/pages/CalendarView.js
import React from "react";

const CalendarView = () => {
  return (
    <div className="p-4">
      <h1>Calendar View</h1>
      <p>Calendar functionality will be implemented here.</p>
    </div>
  );
};

export default CalendarView;
